import React from "react";

const CloseIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 4L4 12M4 4L12 12"
      stroke="#1E1E1E"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const CheckIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 4L6 11L3 8"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const RepresentationRequestButtons = ({ onReject, onAccept }) => {
  return (
    <div className="flex items-center gap-3">
      <button
        type="button"
        onClick={onReject}
        className="px-4 py-2 border border-[#E6E6E6] bg-white flex items-center gap-2 rounded-lg hover:bg-gray-50 transition-colors"
        aria-label="Reject representation request"
      >
        <CloseIcon />
        <span className="text-[#1E1E1E]">Reject</span>
      </button>
      <button
        type="button"
        onClick={onAccept}
        className="px-4 py-2 rounded-lg bg-[#38AB75] text-white flex items-center gap-2 hover:bg-green-600 transition-colors"
        aria-label="Accept player and proceed"
      >
        <CheckIcon />
        <span>Accept Player & Proceed</span>
      </button>
    </div>
  );
};

export default RepresentationRequestButtons;
